import { useMutation, useQueryClient } from "@tanstack/react-query";
import { rmImgCrateApi, rmImgModifyApi } from "components/api/rm";
import { apifield } from "components/utils/comm";
import useAlertStore from "store/alert";
import useLodStore from "store/lod";

import ImgUploadApi from "components/api/imgUpload";
import { upRmFileCd } from "components/constent";
import { FormEvent } from "react";
import { useImagesContext } from "./context";
import { rmImgModifyProps } from "interface/rm/rm";

// 이미지 업로드
export const uploadImage = async (files: FileList) => {
  const { lod } = useLodStore.getState();

  const formData = new FormData();
  formData.append("lodNo", lod?.lodNo ?? "");
  formData.append("imgTypCd", upRmFileCd);

  Array.from(files).forEach((file) => {
    formData.append("uploadFiles", file);
  });

  const res = await ImgUploadApi(formData);

  const {
    status: { code, message },
    data,
  } = res;
  if (code === 0) {
    return data.imgList;
  }
  // 이미지 등록 성공

  if (code === -1) {
    apifield(message);
  }
};

// 이미지 업로드 및 객실 이미지 등록
export const useImgUpload = () => {
  const lod = useLodStore((state) => state.lod);
  const { mutate: createImage } = useRoomImgUpload();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const uploadRoomImage = (rmNo: string, files: FileList) => {
    onSetAlert({
      isOpen: true,
      inner: "이미지를 업로드하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: async () => {
        const formData = new FormData();
        formData.append("lodNo", lod?.lodNo ?? "");
        formData.append("imgTypCd", upRmFileCd);

        Array.from(files).forEach((file) => {
          formData.append("uploadFiles", file);
        });

        const res = await ImgUploadApi(formData);

        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 이미지 등록 성공
          const params = {
            rmNo: rmNo ?? "",
            rmImgList: data.imgList,
          };
          createImage(params);
        }
        if (code === -1) {
          apifield(message);
        }
      },
    });
  };

  return {
    uploadRoomImage,
  };
};

// 객실 이미지 등록
export const useRoomImgUpload = () => {
  const queryClient = useQueryClient();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);

  return useMutation({
    mutationKey: ["room-img-upload"],
    mutationFn: rmImgCrateApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 객실이미지 등록 완료
          onSetAlert({
            isOpen: true,
            inner: "객실이미지 등록이 완료되었습니다.",
            onSetConfirm: () => {
              // 객실리스트 조회 필요 여부
              //   setIsSuccess(true);
              queryClient.invalidateQueries({
                queryKey: ["room-detail", "update"],
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

// 객실 이미지 변경 , 삭제, 순서변경
export const useUpdateImage = () => {
  const queryClient = useQueryClient();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  return useMutation({
    mutationKey: ["room-image-update"],
    mutationFn: rmImgModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 이미지 수정, 삭제 완료 후 새로운 리스트 가져오기
          onSetAlert({
            isOpen: true,
            inner: "이미지 수정을 완료하였습니다.",
            onSetConfirm: () => {
              //   setIsSuccess(true);
              queryClient.invalidateQueries({
                queryKey: ["room-detail", "update"],
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

type ISubmitProps = {
  e: FormEvent<HTMLFormElement>;
};
export const useOnSubmit = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { images, rmNo } = useImagesContext();
  const { mutate: updateImage } = useUpdateImage();
  const { mutate: createImage } = useRoomImgUpload();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const id = e.currentTarget.id;

    // 이미지 등록
    if (id.includes("create")) {
      // 이미지 등록

      const params = {
        rmNo: rmNo ?? "",
        rmImgList: images.map((i) => {
          return i.origin;
        }) as any,
      };

      createImage(params);
    }

    // 이미지 저장
    if (id.includes("update")) {
      const tarRmImgList = images
        .filter((i) => i.type !== "existing")
        .map((i) => {
          if (i.type === "deleted") {
            const origin = {
              rgSeq: i.rgSeq,
              imgTypCd: "I11",
              uyn: "N",
            };
            return origin;
          }
          if (i.type === "order") {
            const origin = {
              rgSeq: i.rgSeq,
              imgTypCd: "I11",
              expsOrdV: i.expsOrdV,
            };
            return origin;
          }
          if (i.type === "updated") {
            return i.origin;
          }
        }) as Array<rmImgModifyProps>;

      if (tarRmImgList.length === 0) {
        onSetAlert({
          isOpen: true,
          inner: "변경된 이미지가 없습니다.",
        });
      }

      if (tarRmImgList.length !== 0) {
        onSetAlert({
          isOpen: true,
          inner: "변경된 이미지를 저장하시겠습니까?",
          cnclBtn: true,
          chkBnt: true,
          onSetConfirm: () => {
            // 삭제 , 순서 변경, 이미지 변경

            if (rmNo) {
              const params = {
                rmNo: rmNo,
                tarRmImgList,
              };
              updateImage(params);
            }
          },
        });
      }
    }
  };

  return {
    onSubmit,
  };
};
